/* unplugin-vue-components disabled */import script from "./publishCdnDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./publishCdnDialog.vue?vue&type=script&setup=true&lang=ts"

import "./publishCdnDialog.vue?vue&type=style&index=0&id=4c67ce5d&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/.pnpm/vue-loader@16.8.3_2s7cwfl64decoaat2pz2tykl6i/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c67ce5d"]])

export default __exports__